import React from 'react';
import { ArrowLeft } from 'lucide-react';

/**
 * BackButton - Standardized back navigation button
 * Used in full-screen views with optional label
 *
 * @param {Function} onClick - Back navigation handler
 * @param {string} label - Optional accessible label
 * @param {string} className - Additional CSS classes
 */
export const BackButton = ({
  onClick,
  label = 'Go back',
  className = ''
}) => {
  return (
    <button
      onClick={onClick}
      className={`inline-flex items-center rounded-md p-1.5 hover:bg-slate-100 text-slate-600 hover:text-slate-900 transition-colors ${className}`}
      aria-label={label}
    >
      <ArrowLeft className="h-5 w-5" />
    </button>
  );
};

export default BackButton;